import WeightCounter from '../../../internal/platformMetrics/aggregators/WeightCounter';
export const safeParams = [
    'request',
    'miss'
];
export const translationCountForMessageLength = new WeightCounter('i18n_translation_format_message_sml_total');

//# sourceMappingURL=translationCountForMessageLength.js.map